import { ReportHistoryContainer } from './reportHistoryContainer';
import { useTranslation } from 'react-i18next';
import { HistoryCategory } from './historyCategory';
import { observer } from 'mobx-react-lite';
import { GraphTypes, useReportsStore } from '../stores';
import { Parameters } from '@web/common';

export const StressReportHistory = observer(() => {
  const { t } = useTranslation(['common', 'reports', 'infoTexts']);
  const reportsStore = useReportsStore();

  return (
    <ReportHistoryContainer>
      <HistoryCategory
        parameters={[
          {
            type: GraphTypes.CATEGORY,
            parameter: Parameters.CARDIOVASCULAR_RISK,
            unit: '',
            data: reportsStore.getCategoryParameterValues(
              Parameters.CARDIOVASCULAR_RISK,
            ),
            thresholds: reportsStore.getParameterThresholds(
              Parameters.CARDIOVASCULAR_RISK,
            ),
            infoText: t('infoTexts:cardiovascular_risk_info'),
          },
          {
            type: GraphTypes.CATEGORY,
            parameter: Parameters.STRESS_LEVEL,
            unit: '',
            data: reportsStore.getCategoryParameterValues(
              Parameters.STRESS_LEVEL,
            ),
            thresholds: reportsStore.getParameterThresholds(
              Parameters.STRESS_LEVEL,
            ),
            infoText: t('infoTexts:stress_level_info'),
          },
        ]}
        maxWidth={1000}
      />
    </ReportHistoryContainer>
  );
});
